import { useCallback, useRef } from 'react';
import { useLayoutEffect } from './useIsomorphicLayoutEffect';
export function useEventHandler(handler) {
    const handlerRef = useRef(null);
    useLayoutEffect(() => {
        handlerRef.current = handler;
    });
    return useCallback((...args) => {
        const handler = handlerRef.current;
        if (handler === null) {
            console.warn('The event handler cannot be called during render');
        }
        return handler === null || handler === void 0 ? void 0 : handler(...args);
    }, []);
}
